import { gql } from '@apollo/client';

export const STRIPE_RETRIEVE_CONNECTED_ACCOUNT = gql`
  query {
    stripeRetrieveConnectedAccount {
      account {
        id
        chargesEnabled
        payoutsEnabled
        defaultAccount {
          id
          last4
          bankName
          currency
        }
      }
    }
  }
`;

export const STRIPE_CREATE_LOGIN_LINK = gql`
  query stripeCreateLoginLink {
    stripeCreateLoginLink {
      url
    }
  }
`;

export const CHANNEL_EXPORT = gql`
  query channelExport($where: ChannelExportWhereInput!) {
    channelExport(where: $where) {
      fileType
      base64Encoding
    }
  }
`;

export const TRIGGER_CLINIC_SYNC = gql`
  mutation triggerClinicSync($clinicId: String!) {
    syncClinic(clinicId: $clinicId)
  }
`;
